import { AspectRatio } from "~/components/ui/aspect-ratio";
import { AspectRatios } from "~/utils/constants";
import Image from "~/components/Image";
import { Link } from "@remix-run/react";
import { SheetClose } from "~/components/ui/sheet";
import { motion } from "framer-motion";

const PopularSearches = ({ locale }: { locale: string }) => {
  const searches = [
    {
      value: locale === "se" ? "blommor" : "flowers",
      label: locale === "se" ? "Blommor" : "Flowers",
      imageUrl:
        "https://cdn.sanity.io/images/n8c7yri3/production/517b175f290e0259fa610dd629037f08b955442d-1024x1280.jpg?w=200&q=100&fit=max&auto=format",
    },
    {
      value: locale === "se" ? "öken" : "desert",
      label: locale === "se" ? "Öken" : "Desert",
      imageUrl:
        "https://cdn.sanity.io/images/n8c7yri3/production/072bb44b18fc2bdd26458e2614513947abc41224-1024x1280.jpg?w=400&q=90&fit=max&auto=format",
    },
    {
      value: locale === "se" ? "konst" : "art",
      label: locale === "se" ? "Konst" : "Art",
      imageUrl:
        "https://cdn.sanity.io/images/n8c7yri3/production/0eeea4210751719341c5d1ab22606d4e30df01a7-1024x1280.jpg?w=300&q=100&fit=max&auto=format",
    },
    {
      value: locale === "se" ? "lugn" : "calm",
      label: locale === "se" ? "Lugn" : "Calm",
      imageUrl:
        "https://cdn.sanity.io/images/n8c7yri3/production/2e9fb9389b7c4ffb11f3365fe51c72cf12191af4-1024x1280.jpg?w=300&q=100&fit=max&auto=format",
    },
  ];

  return (
    <div>
      <h2 className="font-masonExtendedBold">
        {locale === "se" ? "Populära sökningar" : "Popular searches"}
      </h2>
      <ul className="list-none p-0 pl-1 mt-2 place-items-center w-full inline-grid grid-flow-col  gap-2 grid-cols-[repeat(4,75px)] md:grid-cols-[repeat(4,116px)]">
        {searches.map((search) => {
          return (
            <motion.li
              whileHover={{ scale: 1.03 }}
              transition={{
                duration: 0.5,
                ease: [0.19, 1, 0.22, 1],
              }}
              key={search.value}
              className="relative h-full w-full cursor-pointer text-center"
            >
              <SheetClose
                asChild
                className="relative h-full w-full cursor-pointer text-center"
              >
                <Link to={`/${locale}/search?searchTerm=${search.value}`}>
                  <AspectRatio ratio={AspectRatios.tall}>
                    <Image
                      imageSrcUrl={search.imageUrl}
                      alt={`Frame search: ${search.value}`}
                    />
                  </AspectRatio>
                  <span className="leading-3 block font-thin pt-2 text-xs md:text-base">
                    {search.label}
                  </span>
                </Link>
              </SheetClose>
            </motion.li>
          );
        })}
      </ul>
    </div>
  );
};

export default PopularSearches;
